import script from "./InventoryFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryFilters.vue?vue&type=script&setup=true&lang=ts"

import "./InventoryFilters.vue?vue&type=style&index=0&id=4cd8c762&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd8c762"]])

export default __exports__